import { observable, action } from 'mobx';

const defaultGeoSignal = {
  rsrp: '',
  sinr: '',
  ecl: '',
  txpow: '',
  pci: '',
  cellid: ''
};

export default class SignalStore {
  @observable bluetooth = '';

  @observable rssi = ''; // lora 地磁网络信号强度

  @observable geoSignal = Object.assign({}, defaultGeoSignal);

  @action setGeoSignal(data) {
    Object.keys(this.geoSignal).forEach((key) => {
      if (
        key !== 'cellid'
        && key !== 'pci'
        && parseInt(data[key], 10) === -32768
      ) {
        // -32768值无效
        return;
      }

      const formatKeys = ['rsrp', 'sinr', 'txpow'];

      if (formatKeys.indexOf(key) !== -1) {
        this.geoSignal[key] = data[key] ? (data[key] / 10).toFixed(1) : '';
      } else {
        this.geoSignal[key] = data[key] || '';
      }
    });
  }

  @action reset() {
    this.geoSignal = Object.assign({}, defaultGeoSignal);
    this.bluetooth = '';
  }
}

export const signalStore = new SignalStore();
